import { lazy } from 'react';

const HandoverTableComponentLoadable = lazy(
  () => import('./HandoverComponent/HandoverTableComponent'),
);

const HandoverFormComponentLoadable = lazy(
  () => import('./HandoverComponent/HandoverFormComponent'),
);

const HandoverDetailComponentLoadable = lazy(
  () => import('./HandoverComponent/HandoverDetailComponent'),
);

const AoneWaybillIntegrationTableComponentLoadable = lazy(
  () => import('./A-oneWaybills/AoneWaybillTable'),
);

export {
  HandoverTableComponentLoadable,
  HandoverFormComponentLoadable,
  HandoverDetailComponentLoadable,
  AoneWaybillIntegrationTableComponentLoadable,
};
